/**
 * MCP Resources Registration
 *
 * Resources provide read-only access to design system documentation.
 */

import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { registerComponentResources } from './components.js';
import { registerTokenResources } from './tokens.js';
import { registerStylesResources } from './styles.js';
import { registerLayoutResources } from './layouts.js';
import { registerSchemaResources } from './schemas.js';
import { registerAuthResources } from './auth.js';
import { registerNotificationsResources } from './notifications.js';
import { registerDocsResources } from './docs.js';
import { registerChartsResources } from './charts.js';
import { registerMapsResources } from './maps.js';
import { registerNativeResources } from './native.js';

/**
 * Register all resources with the MCP server
 */
export function registerResources(server: McpServer): void {
  registerComponentResources(server);
  registerTokenResources(server);
  registerStylesResources(server);
  registerLayoutResources(server);
  registerSchemaResources(server);
  registerAuthResources(server);
  registerNotificationsResources(server);
  registerDocsResources(server);
  registerChartsResources(server);
  registerMapsResources(server);
  registerNativeResources(server);
}
